// extracted by mini-css-extract-plugin
module.exports = {"container":"CdsCheckoutSummary_container__3nZyJ","total-item":"CdsCheckoutSummary_total-item__3woGd","total-container":"CdsCheckoutSummary_total-container__1aPc7"};